import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";
//
import Screen from "./ConnectedScreen";
import Icon from "../components/Icon";

class VerifyPhoneScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      phone: null,
    };
  }

  onSubmit() {
    const { phone } = this.state;
    const { updateBookingPhone, country } = this.props;

    if (phone) {
      updateBookingPhone(phone, country.id);
    } else {
      this.setState({
        error: true,
      });
    }
  }

  phoneChanged(value) {
    this.setState({
      phone: value,
      error: false,
    });
  }

  enterSubmit(ev) {
    if (ev.key === "Enter") {
      this.onSubmit();
    }
  }

  render() {
    const { errorMessage, country, goTo } = this.props;
    const { phone, error } = this.state;
    const countryValue = `+${country.callingCode} ${country.name}`;

    return (
      <Screen
        title="Verify your phone"
        isActive
        nextLabel="Request OTP"
        onNext={(ev) => this.onSubmit()}
        className="form"
      >
        <p>
          To confirm your booking, please enter your{" "}
          <span className="u-brand">mobile number</span>.
        </p>
        <div className="form__field">
          <label>Select Country</label>
          <div className="input-icon">
            <input
              type="text"
              className="form__control"
              value={countryValue}
              readOnly
              onClick={(ev) => goTo("countries")}
            />
            <Icon name="keyboard_arrow_right" />
          </div>
        </div>
        <div className={cx("form__field", { error })}>
          <label>Mobile Number</label>
          <input
            type="number"
            name="phone"
            value={phone || ""}
            className="form__control"
            placeholder="e.g: 89674523"
            onChange={(ev) => this.phoneChanged(ev.target.value)}
            autoFocus
            onKeyDown={(ev) => this.enterSubmit(ev)}
          />
          {error && (
            <small className="form__error">
              Please provide a phone number.
            </small>
          )}
          <small className="form__help">
            Your actual number will be kept private and never shared with third
            parties.
          </small>
        </div>
        <p className="u-tc u-mv">
          <a className="u-link" onClick={(ev) => goTo("phone-help")}>
            Why we use SMS verfication?
          </a>
        </p>
        {errorMessage !== null && (
          <p className="u-danger u-small u-mt">{errorMessage}</p>
        )}
      </Screen>
    );
  }
}

// @connect
import { updateBookingPhoneAction } from "../modules/booking/actions";

function mapState(state) {
  const { countries } = state;

  return {
    country: countries.entities[countries.active] || null,
  };
}

function mapDispatch(dispatch) {
  return {
    updateBookingPhone(phone, country) {
      dispatch(updateBookingPhoneAction(phone, country));
    },
  };
}

export default connect(
  mapState,
  mapDispatch
)(VerifyPhoneScreen);
